import { DialogActions } from "@mui/material";

const BasicDialogActions = (props) => {
  return <DialogActions {...{sx:{padding:2, paddingTop:0}}}>{props.children}</DialogActions>;
};

export default BasicDialogActions;
